const SideMenuItem = {
  $: 'Flex',
  props: {
    alignItems: 'center',
    color: 'white',
    width: '100%',
  },
  onActive: {
    color: 'white',
    opacity: 1,
  },
  onHover: {
    color: 'white',
    opacity: 1,
  },
  linkProps: {},
  showIcon: true,
  children: (props) => {
    return {
      $: 'WrappedLink',
      props: {
        py: 4,
        width: '100%',
        opacity: 0.4,
        _hover: props.onHover,
        _focus: { boxShadow: 'none' },
        lineHeight: '24px',
        display: 'inline-flex',
        // fontWeight: 'semibold',
        href: props.href,
        ...props.linkProps,
        onClick: () => props.onClick,
        ...(typeof window !== 'undefined' && props.href === window.location.pathname
          ? props.onActive
          : {}),
      },
      children: [
        props.showIcon && {
          component: props.icon,
          props: {
            fontSize: 24,
            minWidth: '40px',
          },
        },
        !props.iconOnly
          ? { $: 'Text', props: { pl: props.showIcon ? 4 : 0 }, children: props.label }
          : '',
      ],
    };
  },
};

export default SideMenuItem;
